import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {setChangeSearchAC} from 'features/beersManager/slice';
import ZeroState from 'features/beersManager/Table/ZeroState/ZeroState';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {Beer} from 'typescript/models/Beer';

import './AddBeersBody.scss';
import AddBeersRow from './AddBeersRow/AddBeersRow';

interface IProps {
  beersList: Beer[];
}

const AddBeersBody = ({beersList}: IProps) => {
  const {currentSearch, fallbackSearch} = useGlobalState((state) => state.beersManager);
  const dispatch = useSetGlobalState();

  const hasBeersList = beersList.length > 0;

  const handleChangeSearch = () => dispatch(setChangeSearchAC(true));

  return (
    <tbody data-testid="add-beers-body">
      {hasBeersList && beersList.map((beer) => <AddBeersRow beer={beer} key={beer.id} />)}
      {!hasBeersList && (
        <ZeroState>
          <div className="add-beers-body__zero-state" data-testid="add-beers-body-zero-state">
            {currentSearch && (
              <>
                <div>
                  <Text data-testid="add-beers-body-current-search" tag="span">
                    There isn&apos;t a match for <Text tag="span">{currentSearch}.</Text>
                  </Text>
                </div>
                <Button variant="empty" onClick={handleChangeSearch}>
                  <Text tag="span">
                    Try for
                    <Text
                      data-testid="add-beers-body-fallback-search"
                      tag="span"
                      className="add-beers-body__suggestion"
                    >
                      {fallbackSearch}
                    </Text>
                  </Text>
                </Button>
              </>
            )}
            {!currentSearch && (
              <div data-testid="add-beers-body-zero-state-2">
                <Text tag="span">No beers found</Text>
              </div>
            )}
          </div>
        </ZeroState>
      )}
    </tbody>
  );
};

export default AddBeersBody;
